import {
  CREATE_CUSTOMER_REPORT_RESPONSE,
  GET_CUSTOMER_REPORT_RESPONSE,
  GET_CUSTOMER_REPORT_ACTION_RESPONSE,
} from 'actions/grace';

const initialState = {
  nextStageOptions: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CUSTOMER_REPORT_RESPONSE:
    case GET_CUSTOMER_REPORT_RESPONSE:
      return {
        nextStageOptions: action.response.customerReport?.nextStage?.options,
      };
    case GET_CUSTOMER_REPORT_ACTION_RESPONSE:
      return {
        nextStageOptions: action.response.resolver.nextStageOptions,
      };
    default:
      return state;
  }
};
